import * as React from 'react';
export const sequraSvg = React.forwardRef(function sequraSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00C2A3',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.336 22.867a8.19 8.19 0 0 1-2.063-.34c-.075-.025-.105-.117-.05-.176a10.391 10.391 0 0 0 2.39-4.607 10.146 10.146 0 0 0-1.032-7.177c-1.217-2.194-3.209-3.911-5.619-4.826a11.362 11.362 0 0 0-7.53-.19c-2.455.798-4.537 2.408-5.87 4.54a10.188 10.188 0 0 0-1.419 7.113c.423 2.457 1.74 4.695 3.712 6.305 1.897 1.547 4.306 2.428 6.787 2.491h.02a.684.684 0 0 0 .523-.238.7.7 0 0 0 .16-.448v-1.78a.683.683 0 0 0-.673-.672 7.913 7.913 0 0 1-4.709-1.747 7.33 7.33 0 0 1-2.605-4.422 7.155 7.155 0 0 1 .99-4.992c.936-1.499 2.4-2.627 4.12-3.187a7.996 7.996 0 0 1 5.292.131 7.58 7.58 0 0 1 3.944 3.392 7.109 7.109 0 0 1 .724 5.03 7.323 7.323 0 0 1-2.072 3.64c-.03.029-.161.029-.196 0a7.357 7.357 0 0 1-1.665-2.39 7.087 7.087 0 0 1-.579-2.568.684.684 0 0 0-.694-.652h-1.856a.749.749 0 0 0-.473.16.647.647 0 0 0-.237.516c.036 1.29.312 2.55.83 3.747a10.416 10.416 0 0 0 2.37 3.405 10.96 10.96 0 0 0 3.546 2.277c1.243.497 2.556.764 3.899.798h.02a.678.678 0 0 0 .518-.233.665.665 0 0 0 .161-.448v-1.78a.682.682 0 0 0-.674-.672',
      fill: '#fff',
    }),
  );
});
sequraSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sequra = {
  category: 'brand',
  colorable: false,
  name: 'sequra',
  svg: sequraSvg,
};
